export const FIRE_BASE_LOGIN = 'firebase cloud login';
export const LOGIN = 'logged in';
export const LOGOUT = 'logged out';
export const UPDATE_USER = 'update user';
export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USER_SUCESS';
export const FETCH_USERS_FAILURE = 'FETCH_USER_FAILURE';
export const BELL_NOTIFICATION = 'bell notification data';

export const OPEN_SNACK = 'open-snack';
export const OPEN_SNACK_LOADING = 'open-snack-loading';
export const OPEN_SNACK_ERROR = 'open-snack-error';
export const CLOSE_SNACK = 'close snack bar';

export const SET_TEAM_USER = 'set team user for mattermost';
export const SET_CHAT_ROOM = 'set chat room config';

export const SET_GOLOBAL_LANGUAGE = 'set global app language and layout rtl ltr';
export const SET_GOLOBAL_THEME_MODE = 'set global app dark light Mode';
